<div class="main-container">
  <!-- Header Section -->
  <div class="page-header">
    <div class="routing-buttons">
      <div
        class="action-button back-button"
        (click)="navigateBack()"
        tabindex="0"
        (keydown.enter)="navigateBack()"
      >
        <mat-icon class="icon back-icon">arrow_back</mat-icon>
      </div>
      <div
        class="action-button reload-button"
        (click)="ngOnInit()"
        tabindex="0"
        (keydown.enter)="ngOnInit()"
      >
        <mat-icon class="icon reload-icon">refresh</mat-icon>
      </div>
      <span class="page-title"> FOTA Batch Report</span>
    </div>
  </div>

  <!-- List Section -->
  <div class="component-container">
    <div class="component-header">
      <h6 class="component-title">FOTA Batch Report Filter Details</h6>
    </div>

    <!-- Separator between Header and Body -->
    <div class="component-separator"></div>

    <div class="component-container">
      <div class="form-section">
        <div class="form-group">
          <mat-form-field appearance="outline">
            <mat-label>Report Type</mat-label>
            <mat-select (selectionChange)="onReportTypeChange($event.value)">
              <mat-option value="Date">Date</mat-option>
              <mat-option value="Batch ID">Batch ID</mat-option>
              <mat-option value="Batch ID List">Batch ID List</mat-option>
              <mat-option value="IMEI List">IMEI List</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      @if (reportType === 'Date') {
        <form [formGroup]="fotaReportDateForm" novalidate>
          <div class="form-section">
            <div class="form-group">
              <mat-form-field appearance="outline">
                <mat-label>From Date</mat-label>
                <input
                  formControlName="fromDate"
                  matInput
                  [matDatepicker]="fromDate"
                  [max]="today"
                  [max]="fotaReportDateForm.value.toDate || today"
                  id="fromDate"
                  placeholder="From Date"
                  readonly
                />
                <mat-datepicker-toggle matSuffix [for]="fromDate">
                </mat-datepicker-toggle>
                <mat-datepicker #fromDate></mat-datepicker>
                @if (
                  fotaReportDateForm.controls['fromDate'].touched &&
                  fotaReportDateForm.controls['fromDate'].errors?.required
                ) {
                  <mat-error> This field is mandatory. </mat-error>
                }
                @if (
                  fotaReportDateForm.controls['fromDate'].hasError(
                    'invalidDateRange'
                  )
                ) {
                  <mat-error>
                    From Date should not be greater than To Date.
                  </mat-error>
                }
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field appearance="outline">
                <mat-label>To Date</mat-label>
                <input
                  formControlName="toDate"
                  matInput
                  [matDatepicker]="toDate"
                  id="toDate"
                  [max]="today"
                  [min]="fotaReportDateForm.value.fromDate || ''"
                  placeholder="To Date"
                  readonly
                />
                <mat-datepicker-toggle matSuffix [for]="toDate">
                </mat-datepicker-toggle>
                <mat-datepicker #toDate></mat-datepicker>
                @if (
                  fotaReportDateForm.controls['toDate'].touched &&
                  fotaReportDateForm.controls['toDate'].errors?.required
                ) {
                  <mat-error> This field is mandatory. </mat-error>
                }
                @if (
                  fotaReportDateForm.controls['toDate'].hasError(
                    'invalidDateRange'
                  )
                ) {
                  <mat-error>
                    To Date should not be lesser than From Date.
                  </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </form>
      }
      @if (reportType === 'Batch ID') {
        <form [formGroup]="fotaReportBatchIdForm" novalidate>
          <div class="form-section">
            <div class="form-group">
              <mat-form-field appearance="outline">
                <mat-label>From Batch ID</mat-label>
                <input
                  type="number"
                  formControlName="fromBatchId"
                  matInput
                  id="fromBatchId"
                  [max]="fotaReportBatchIdForm.value.toBatchId || null"
                  [min]="1"
                  placeholder="From Batch Id"
                />
                @if (
                  fotaReportBatchIdForm.controls['fromBatchId'].touched &&
                  fotaReportBatchIdForm.controls['fromBatchId'].errors?.required
                ) {
                  <mat-error> This field is mandatory. </mat-error>
                }
                @if (
                  fotaReportBatchIdForm.controls['fromBatchId'].hasError(
                    'invalidNumberRange'
                  )
                ) {
                  <mat-error>
                    From Batch ID should not be greater than To Batch ID.
                  </mat-error>
                }
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field appearance="outline">
                <mat-label>To Batch ID</mat-label>
                <input
                  type="number"
                  formControlName="toBatchId"
                  matInput
                  id="toBatchId"
                  [min]="fotaReportBatchIdForm.value.fromBatchId || 1"
                  placeholder="To Batch ID"
                />
                @if (
                  fotaReportBatchIdForm.controls['toBatchId'].touched &&
                  fotaReportBatchIdForm.controls['toBatchId'].errors?.required
                ) {
                  <mat-error> This field is mandatory. </mat-error>
                }
                @if (
                  fotaReportBatchIdForm.controls['toBatchId'].hasError(
                    'invalidNumberRange'
                  )
                ) {
                  <mat-error>
                    To Batch ID should not be lesser than From Batch ID.
                  </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </form>
      }
      @if (reportType === 'Batch ID List') {
        <form [formGroup]="fotaReportBatchIdArrayForm" novalidate>
          <div class="form-section">
            <div class="form-group">
              <mat-form-field appearance="outline">
                <mat-label>From Batch List</mat-label>
                <input
                  formControlName="batchIdList"
                  matInput
                  id="batchIdList"
                  placeholder="Batch List"
                />
                @if (
                  fotaReportBatchIdArrayForm.controls['batchIdList'].touched &&
                  fotaReportBatchIdArrayForm.controls['batchIdList'].errors
                    ?.required
                ) {
                  <mat-error> This field is mandatory. </mat-error>
                }
                @if (
                  fotaReportBatchIdArrayForm.controls['batchIdList'].hasError(
                    'invalidFormat'
                  )
                ) {
                  <mat-error> Invalid format (check commas) </mat-error>
                }
                @if (
                  fotaReportBatchIdArrayForm.controls['batchIdList'].hasError(
                    'invalidNumber'
                  )
                ) {
                  <mat-error> Only numbers are allowed </mat-error>
                }
                @if (
                  fotaReportBatchIdArrayForm.controls['batchIdList'].hasError(
                    'duplicateValues'
                  )
                ) {
                  <mat-error> Duplicate values are not allowed </mat-error>
                }
                @if (
                  fotaReportBatchIdArrayForm.controls['batchIdList'].hasError(
                    'invalidRange'
                  )
                ) {
                  <mat-error> Values must be greater than 0 </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </form>
      }
      @if (reportType === 'IMEI List') {
        <form [formGroup]="fotaReportImeiForm" novalidate>
          <div class="form-section">
            <div class="form-group">
              <mat-form-field appearance="outline">
                <mat-label>IMEI List</mat-label>
                <input
                  formControlName="imeiList"
                  matInput
                  id="imeiList"
                  placeholder="IMEI List"
                />
                @if (
                  fotaReportImeiForm.controls['imeiList'].touched &&
                  fotaReportImeiForm.controls['imeiList'].errors?.required
                ) {
                  <mat-error> This field is mandatory. </mat-error>
                }
                @if (
                  fotaReportImeiForm.controls['imeiList'].hasError(
                    'invalidFormat'
                  )
                ) {
                  <mat-error> Invalid format (check commas) </mat-error>
                }
                @if (
                  fotaReportImeiForm.controls['imeiList'].hasError(
                    'invalidNumber'
                  )
                ) {
                  <mat-error> Only numbers are allowed </mat-error>
                }
                @if (
                  fotaReportImeiForm.controls['imeiList'].hasError(
                    'duplicateValues'
                  )
                ) {
                  <mat-error> Duplicate values are not allowed </mat-error>
                }
                @if (
                  fotaReportImeiForm.controls['imeiList'].hasError(
                    'invalidRange'
                  )
                ) {
                  <mat-error> Values must be greater than 0 </mat-error>
                }
                @if (
                  fotaReportImeiForm.controls['imeiList'].hasError(
                    'invalidLength'
                  )
                ) {
                  <mat-error> Each value must be of 15 length </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </form>
      }
    </div>

    @if (reportType !== '') {
      <!-- Separator between Body and Footer -->
      <div class="component-separator"></div>

      <!-- Component Footer Section -->
      <div class="component-footer">
        <div class="button-group">
          @if (reportType !== 'IMEI List') {
            <button
              type="button"
              [disabled]="isDownloading"
              (click)="getFotaBatchSummaryReport()"
              class="submit-button"
            >
              Batch Report
              <mat-icon class="btn-icon">download</mat-icon>
            </button>
          }
          <button
            type="button"
            [disabled]="isDownloading"
            (click)="getDeviceInFotaBatchSummaryReport()"
            class="submit-button"
          >
            Device Report
            <mat-icon class="btn-icon">download</mat-icon>
          </button>
          <button
            class="primary-button"
            type="button"
            [disabled]="isDownloading"
            (click)="downloadAllDevicesUnderFOTAProcessReport()"
          >
            All Devices under FOTA process
            <mat-icon class="btn-icon">download</mat-icon>
          </button>
          <button type="button" (click)="clear()" class="clear-button">
            Clear
            <mat-icon class="btn-icon">clear</mat-icon>
          </button>
        </div>
      </div>
    }
  </div>
</div>
